import React, { useRef, useState } from "react";
import { Box, TextField, Grid, Typography } from "@mui/material";
import { Button, Stack, Dialog, DialogContent } from "@mui/material";
import backIcon from "../../images/backIcon.svg";
import { BodyContainer, ButtonAdd, Header, TopGrid } from "../styles";
import { Link, useHistory } from "react-router-dom";
import DividerWithText from "./DividerWithText";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "./schema";
import { UploadImage } from "../../utils/UploadImage";
import { userDetails } from "./httpCalls";
import { useDispatch } from "react-redux";
import moment from "moment";
import { UserDetailsPrint } from "./Print";

function AddSale() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [state, setState] = useState({
    sProfile: "",
    cProfile: "",
    modal: false,
    data: "",
    ready: false,
  });
  const componentRef = useRef(state.data || null);
  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });
  const submit = async (data) => {
    let sProfile = "";
    let cProfile = "";
    if (state.sProfile) {
      sProfile = await UploadImage(state.sProfile);
    }
    if (state.cProfile) {
      cProfile = await UploadImage(state.cProfile);
    }
    data.sProfile = sProfile;
    data.cProfile = cProfile;
    data.date = moment().format("DD-MM-YYYY");
    setState((prev) => ({ ...prev, modal: !prev.modal, data: data }));
  };

  const handleImage = (e) => {
    let { name, files } = e.target;
    setState((state) => ({ ...state, [name]: files[0] }));
  };

  const toggle = () => {
    setState((prev) => ({ ...prev, modal: !prev.modal }));
  };

  const create = async () => {
    setState((prev) => ({ ...prev, modal: !prev.modal }));
    await userDetails(state.data);
    history.push("/inventory/admin/user-details");
  };

  return (
    <Box>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center">
          <Grid align="center" item md={10} xs={12}>
            <Typography variant="h5" sx={{ color: "white" }}>
              Add User Details
            </Typography>
          </Grid>

          <Grid
            item
            md={2}
            xs={12}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Link to="/inventory/admin/user-details">
              <ButtonAdd variant="contained" fullWidth>
                Back <img src={backIcon} alt="add" />
              </ButtonAdd>
            </Link>
          </Grid>
        </TopGrid>
      </Header>
      <BodyContainer
        sx={{ position: "relative", top: { md: "0px", xs: "40px" } }}
      >
        <DividerWithText title={"Seller Info"} />
        <Grid container spacing={1}>
          <Grid item lg={3} md={6} xs={12}>
            <TextField
              fullWidth
              error={errors.sName?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              label="Seller Name"
              {...register("sName")}
            />
          </Grid>
          <Grid item lg={3} md={6} xs={12}>
            <TextField
              fullWidth
              error={errors.sFatherName?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              label="Father Name"
              {...register("sFatherName")}
            />
          </Grid>
          <Grid item lg={3} md={6} xs={12}>
            <TextField
              fullWidth
              error={errors.sContact?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              label="Contact No."
              type="number"
              {...register("sContact")}
            />
          </Grid>
          <Grid item lg={3} md={6} xs={12}>
            <TextField
              fullWidth
              error={errors.sCNIC?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              label="CNIC"
              type="number"
              {...register("sCNIC")}
            />
          </Grid>

          <Grid item md={8} xs={12}>
            <TextField
              fullWidth
              error={errors.sAddress?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              label="Address"
              {...register("sAddress")}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextField
              fullWidth
              type="file"
              sx={{ background: "white" }}
              size="small"
              name="sProfile"
              onChange={handleImage}
            />
          </Grid>
        </Grid>
        <DividerWithText title={"Customer Info"} />
        <Grid container spacing={1}>
          <Grid item lg={3} md={6} xs={12}>
            <TextField
              fullWidth
              error={errors.cName?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              label="Customer Name"
              {...register("cName")}
            />
          </Grid>
          <Grid item lg={3} md={6} xs={12}>
            <TextField
              fullWidth
              error={errors.cFatherName?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              label="Father Name"
              {...register("cFatherName")}
            />
          </Grid>
          <Grid item lg={3} md={6} xs={12}>
            <TextField
              fullWidth
              error={errors.cContact?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              type="number"
              label="Contact No."
              {...register("cContact")}
            />
          </Grid>
          <Grid item lg={3} md={6} xs={12}>
            <TextField
              fullWidth
              error={errors.cCNIC?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              label="CNIC"
              type="number"
              {...register("cCNIC")}
            />
          </Grid>

          <Grid item md={8} xs={12}>
            <TextField
              fullWidth
              error={errors.cAddress?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              label="Address"
              {...register("cAddress")}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextField
              fullWidth
              sx={{ background: "white" }}
              size="small"
              type="file"
              name="cProfile"
              onChange={handleImage}
            />
          </Grid>
        </Grid>
        <DividerWithText title={"Vehicle Info"} />
        <Grid container spacing={1}>
          <Grid item lg={3} md={6} xs={12}>
            <TextField
              fullWidth
              error={errors.vRegistration?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              label="Vehicle Reg No."
              {...register("vRegistration")}
            />
          </Grid>

          <Grid item lg={3} md={6} xs={12}>
            <TextField
              fullWidth
              sx={{ background: "white" }}
              size="small"
              label="Maker"
              {...register("vMaker")}
            />
          </Grid>

          <Grid item lg={3} md={6} xs={12}>
            <TextField
              fullWidth
              error={errors.vEngine?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              label="Engine No."
              {...register("vEngine")}
            />
          </Grid>
          <Grid item lg={3} md={6} xs={12}>
            <TextField
              fullWidth
              error={errors.vChesis?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              label="Chesis No."
              {...register("vChesis")}
            />
          </Grid>
          <Grid item lg={1.5} md={6} xs={12}>
            <TextField
              fullWidth
              error={errors.vModel?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              label="Model"
              type="number"
              {...register("vModel")}
            />
          </Grid>
          <Grid item lg={1.5} md={6} xs={12}>
            <TextField
              fullWidth
              sx={{ background: "white" }}
              size="small"
              label="Color"
              {...register("vColor")}
            />
          </Grid>
          <Grid item lg={3} md={6} xs={12}>
            <TextField
              fullWidth
              error={errors.vAmountNumbers?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              type="number"
              label="Sum of Rs"
              {...register("vAmountNumbers")}
            />
          </Grid>

          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              sx={{ background: "white" }}
              size="small"
              label="Amount in words"
              {...register("vAmountWords")}
            />
          </Grid>
        </Grid>
        <DividerWithText title={"Payment"} />
        <Grid container spacing={1}>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              multiline
              rows={2}
              sx={{ background: "white" }}
              size="small"
              type="number"
              label="Dealer Commission"
              {...register("commission")}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              fullWidth
              multiline
              rows={2}
              error={errors.paymentDetails?.message ? true : false}
              sx={{ background: "white" }}
              size="small"
              label="Payment Details"
              {...register("paymentDetails")}
            />
          </Grid>
        </Grid>
        <Stack justifyContent="flex-end" marginTop="10px">
          <Button
            size="small"
            variant="contained"
            onClick={handleSubmit(submit)}
          >
            Create
          </Button>
        </Stack>
      </BodyContainer>

      <Dialog
        title="Add"
        open={state.modal}
        onClose={toggle}
        fullWidth
        maxWidth="md"
        sx={{ minHeight: "500px" }}
      >
        <DialogContent dividers={scroll === "paper"}>
          <>
            <Button
              onClick={toggle}
              variant="contained"
              sx={{
                borderRadius: "5px",
                textTransform: "none",
                cursor: "pointer",
                mr: 2,
              }}
            >
              Go Back
            </Button>
            <Button
              variant="contained"
              sx={{
                borderRadius: "5px",
                textTransform: "none",
                cursor: "pointer",
              }}
              onClick={create}
            >
              Print Reciept
            </Button>
            <UserDetailsPrint detail={state.data} />
          </>
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default AddSale;
